import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Star } from "lucide-react";
import { admin } from "../../lib/api";
import { panel, inputCls, btnPrimary, btnGhost, PageHead } from "../ui";

const STATUSES = ["", "pending", "approved", "rejected", "hidden"];

export default function Reviews() {
  const [list, setList] = useState([]);
  const [status, setStatus] = useState("pending");
  const [replyFor, setReplyFor] = useState(null);
  const [replyText, setReplyText] = useState("");

  const load = () => admin.get(`/admin/reviews${status ? `?status=${status}` : ""}`).then((r) => setList(r.data));
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [status]);

  const setStatusFor = async (r, s) => { await admin.put(`/admin/reviews/${r.id}`, { status: s }); toast.success(s); load(); };
  const del = async (r) => { if (!window.confirm("Delete review?")) return; await admin.delete(`/admin/reviews/${r.id}`); load(); };
  const saveReply = async (r) => { await admin.put(`/admin/reviews/${r.id}`, { reply: replyText }); setReplyFor(null); setReplyText(""); toast.success("Reply saved"); load(); };

  return (
    <div>
      <PageHead title="Reviews">
        <select value={status} onChange={(e) => setStatus(e.target.value)} className={`${inputCls} w-40`} data-testid="review-status-filter">
          {STATUSES.map((s) => <option key={s} value={s}>{s || "All"}</option>)}
        </select>
      </PageHead>
      <div className="space-y-3">
        {list.length === 0 && <p className="text-zinc-500">No reviews.</p>}
        {list.map((r) => (
          <div key={r.id} className={`${panel} p-4`} data-testid={`review-${r.id}`}>
            <div className="flex items-start justify-between gap-4 flex-wrap">
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <div className="flex">{[1,2,3,4,5].map((i) => <Star key={i} size={13} className={i <= r.rating ? "fill-current text-amber-400" : "text-zinc-600"} />)}</div>
                  {r.verified_buyer && <span className="text-[10px] uppercase tracking-wider text-accent">Verified</span>}
                  <span className={`text-[10px] uppercase tracking-wider px-1.5 ${r.status === "approved" ? "text-green-400" : r.status === "pending" ? "text-amber-400" : "text-zinc-500"}`}>{r.status}</span>
                </div>
                {r.title && <p className="text-sm font-semibold text-white mt-1">{r.title}</p>}
                <p className="text-sm text-zinc-400 mt-1">{r.text}</p>
                <p className="text-[11px] text-zinc-600 mt-1">{r.customer_name} · {r.product_name}</p>
                {r.reply && <p className="text-xs text-zinc-400 mt-2 pl-2 border-l-2 border-accent-ss">Reply: {r.reply}</p>}
              </div>
            </div>
            <div className="flex gap-2 mt-3 flex-wrap">
              {r.status !== "approved" && <button onClick={() => setStatusFor(r, "approved")} className={btnPrimary} data-testid={`approve-${r.id}`}>Approve</button>}
              {r.status !== "rejected" && <button onClick={() => setStatusFor(r, "rejected")} className={btnGhost}>Reject</button>}
              {r.status !== "hidden" && <button onClick={() => setStatusFor(r, "hidden")} className={btnGhost}>Hide</button>}
              <button onClick={() => { setReplyFor(r.id); setReplyText(r.reply || ""); }} className={btnGhost}>Reply</button>
              <button onClick={() => del(r)} className="text-zinc-500 hover:text-red-400 ml-auto text-xs uppercase tracking-wider">Delete</button>
            </div>
            {replyFor === r.id && (
              <div className="flex gap-2 mt-3">
                <input value={replyText} onChange={(e) => setReplyText(e.target.value)} placeholder="Reply as StreetSins…" className={inputCls} />
                <button onClick={() => saveReply(r)} className={btnPrimary}>Save</button>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
